import type { ChangeEvent } from 'react';

interface Props {
    childAge: number;
    roomIndex: number;
    childIndex: number;
    setChildAge: (age: number) => void;
}

const childAges = (
    <>
        <option value="0">Under 1 år</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
        <option value="13">13</option>
        <option value="14">14</option>
        <option value="15">15</option>
        <option value="16">16</option>
        <option value="17">17</option>
    </>
);

export const ChildAgePicker = ({ childAge, roomIndex, childIndex, setChildAge }: Props) => (
    <div className="flex flex-justify-space-between u-mh16--lt768 u-mb16">
        <label
            className="u-pl2 u-truncate u-mt16--lt768"
            style={{ fontWeight: 400, fontSize: '16px', lineHeight: '18px', color: '#767676' }}
            htmlFor={`room-${roomIndex}-child-${childIndex}`}>
            Alder på barn {childIndex + 1}
        </label>
        <div className="input--select__wrap" style={{ width: '50%' }}>
            <select
                data-testid={`set-child-age-${roomIndex}`}
                id={`room-${roomIndex}-child-${childIndex}`}
                style={{ paddingTop: 0, paddingBottom: 0, height: '40px' }}
                size={1}
                value={childAge}
                onChange={(event: ChangeEvent<HTMLSelectElement>) => setChildAge(~~event.target.value)}>
                {childAges}
            </select>
        </div>
    </div>
);
